import { render, staticRenderFns } from "./CppView.vue?vue&type=template&id=2270c740&"
import script from "./CppView.vue?vue&type=script&lang=js&"
export * from "./CppView.vue?vue&type=script&lang=js&"
import style0 from "./CppView.vue?vue&type=style&index=0&id=2270c740&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports